export class Umfrage {
  guid: string;
  unternehmenGuid: string;
  titel: string;
  isDeleted: number;

  assessmentVersion: number = 1; // 1 = vollständig; 2 = kurz

  themenumfrage: boolean | null;
  startdatum: Date | null;
  enddatum: Date | null;

  bewertungsumfrage: boolean | null;
  bewertungStartdatum: Date | null;
  bewertungEnddatum: Date | null;

  insideOutWert: number;
  ioWertGrund: string;

  outsideInWert: number;
  oiWertGrund: string;

  longlist: Array<LongList>;

  constructor() {
    this.guid = '';
    this.unternehmenGuid = '';
    this.titel = '';

    this.themenumfrage = null;
    this.startdatum = null;
    this.enddatum = null;

    this.bewertungsumfrage = null;
    this.bewertungStartdatum = null;
    this.bewertungEnddatum = null;

    this.isDeleted = 0;

    this.insideOutWert = 0;
    this.ioWertGrund = '';

    this.outsideInWert = 0;
    this.oiWertGrund = '';

    this.longlist = new Array<LongList>();
  }
}

export class LongList {
  id: number;
  unternehmenGuid: string;
  umfrageGuid: string;
  frageid: number | null;
  themaid: number | null;

  longlistSelected: boolean;
  ausschlussBegruendung: string;
  zustimmung: number;

  beantwortet: number;
  relevant: number;
  nichtRelevant: number;

  // Wirkungsrichtung
  insideOut: boolean;
  outsideIn: boolean;
  bothWays: boolean;
  // richtungDontKnow: number;

  // Wirkungszeitraum
  shortTerm: boolean;
  mediumTerm: boolean;
  longTerm: boolean;
  // termDontKnow: number;

  // Wertschöpfungskette
  wertKetteVor: boolean;
  wertKetteEigen: boolean;
  wertKetteNach: boolean;

  // Inside-Out Poistiv (IOP) Bewertung
  iopBewerten: boolean;
  iopReal: number; // 0 = nicht bewertet, 1 = tatsächlich, 2 = potenziell
  iopAusmass: number; // 1 - 6
  iopUmfang: number; // 1 - 6
  iopWkt: number; // Wahrscheinlichkeit, 1 - 6, nur wenn IOPReal = 2 => also Thema potenziell bewertet
  iopBeschreibung: string; // Beschreibung was die positive Auswirkung ist
  iopBewertungGrund: string; // Begründung zur Bewertung
  iopBewertungWert: number; // Berechnet aus IOPAusmass, IOPUmfang und ggf. IOPWkt

  // Inside-Out Negativ (ION) Bewertung
  ionBewerten: boolean;
  ionReal: number; // 0 = nicht bewertet, 1 = tatsächlich, 2 = potenziell
  ionAusmass: number; // 1 - 6
  ionUmfang: number; // 1 - 6
  ionBehebbarkeit: number; // 1 - 6
  ionWkt: number; // Wahrscheinlichkeit, 1 - 6, nur wenn IONReal = 2 => also Thema potenziell bewertet
  ionBeschreibung: string; // Beschreibung was die negative Auswirkung ist
  ionBewertungGrund: string; // Begründung zur Bewertung
  ionBewertungWert: number; // Berechnet aus IONAusmass, IONUmfang, IONBehebbarkeit und ggf. IONWkt

  // Outside-In Chance (OIC) Bewertung
  oicBewerten: boolean;
  oicAuswirkung: number; // 1 - 6
  oicWkt: number; // Wahrscheinlichkeit, 1 - 6
  oicBeschreibung: string; // Beschreibung was die Chance ist
  oicBewertungGrund: string; // Begründung zur Bewertung
  oicBewertungWert: number; // Berechnet aus OICAuswirkung und OICWkt

  // Outside-In Risiko (OIR) Bewertung
  oirBewerten: boolean;
  oirAuswirkung: number; // 1 - 6
  oirWkt: number; // Wahrscheinlichkeit, 1 - 6
  oirBeschreibung: string; // Beschreibung was das Risiko ist
  oirBewertungGrund: string; // Begründung zur Bewertung
  oirBewertungWert: number; // Berechnet aus OIRAuswirkung und OIRWkt

  stakeholder: Array<LongListStakeholder>;

  constructor(unternehmenGuid: string, umfrageGuid: string, frageid: number | null, themaid: number | null, zustimmung: number) {
    this.id = 0;

    this.unternehmenGuid = unternehmenGuid;
    this.umfrageGuid = umfrageGuid;

    this.frageid = frageid;
    this.themaid = themaid;

    this.longlistSelected = false;
    this.ausschlussBegruendung = '';
    this.zustimmung = zustimmung;

    this.beantwortet = 0;
    this.relevant = 0;
    this.nichtRelevant = 0;

    this.insideOut = false;
    this.outsideIn = false;
    this.bothWays = false;
    // this.richtungDontKnow = 0;

    this.shortTerm = false;
    this.mediumTerm = false;
    this.longTerm = false;
    // this.termDontKnow = 0;

    this.wertKetteVor = false;
    this.wertKetteEigen = false;
    this.wertKetteNach = false;

    // Inside-Out Poistiv (IOP) Bewertung
    this.iopBewerten = false;
    this.iopReal = 0;
    this.iopAusmass = 0;
    this.iopUmfang = 0;
    this.iopWkt = 0;
    this.iopBeschreibung = '';
    this.iopBewertungGrund = '';
    this.iopBewertungWert = 0;

    // Inside-Out Negativ (ION) Bewertung
    this.ionBewerten = false;
    this.ionReal = 0;
    this.ionAusmass = 0;
    this.ionUmfang = 0;
    this.ionBehebbarkeit = 0;
    this.ionWkt = 0;
    this.ionBeschreibung = '';
    this.ionBewertungGrund = '';
    this.ionBewertungWert = 0;

    // Outside-In Chance (OIC) Bewertung
    this.oicBewerten = false;
    this.oicAuswirkung = 0;
    this.oicWkt = 0;
    this.oicBeschreibung = '';
    this.oicBewertungGrund = '';
    this.oicBewertungWert = 0;

    // Outside-In Risiko (OIR) Bewertung
    this.oirBewerten = false;
    this.oirAuswirkung = 0;
    this.oirWkt = 0;
    this.oirBeschreibung = '';
    this.oirBewertungGrund = '';
    this.oirBewertungWert = 0;

    this.stakeholder = new Array<LongListStakeholder>();
  }
}

export class LongListStakeholder {
  id: number;
  longlistid: number;
  stakeholderid: number;

  constructor(longlistId: number, stakeholderId: number) {
    this.id = 0;
    this.longlistid = longlistId;
    this.stakeholderid = stakeholderId;
  }
}

export class SetLongListStakeholderObject {
  umfrageGuid: string;
  stakeholder: Array<LongListStakeholder>;

  constructor(umfrageGuid: string, stakeholder: Array<LongListStakeholder>) {
    this.umfrageGuid = umfrageGuid;
    this.stakeholder = stakeholder;
  }
}

export class BewertungAntwort {
  id: number;
  teilnehmerGuid: string;
  unternehmenGuid: string;
  umfrageGuid: string;
  longlistId: number;

  // Info
  insideOut: number; // aus Longlist
  outsideIn: number; // aus Longlist
  bothWays: number; // aus Longlist

  nr: number; // aus Fragenkatalog
  quelle: string; // aus Fragenkatalog
  aspektDE: string; // aus Fragenkatalog
  aspektEN: string; // aus Fragenkatalog
  themaDE: string; // aus Fragenkatalog
  themaEN: string; // aus Fragenkatalog
  frageDE: string; // aus Fragenkatalog
  frageEN: string; // aus Fragenkatalog

  beschreibungDE: string; // aus Fragenkatalog
  ioPositivAuswirkungDE: string = ''; // aus Fragenkatalog
  ioNegativAuswirkungDE: string = ''; // aus Fragenkatalog
  oiChanceAuswirkungDE: string = ''; // aus Fragenkatalog
  oiRisikoAuswirkungDE: string = ''; // aus Fragenkatalog

  beschreibungEN: string; // aus Fragenkatalog
  ioPositivAuswirkungEN: string = ''; // aus Fragenkatalog
  ioNegativAuswirkungEN: string = ''; // aus Fragenkatalog
  oiChanceAuswirkungEN: string = ''; // aus Fragenkatalog
  oiRisikoAuswirkungEN: string = ''; // aus Fragenkatalog

  // Inside-Out Poistiv (IOP) Bewertung
  iopBewerten: boolean;
  iopReal: number; // 0 = nicht bewertet, 1 = tatsächlich, 2 = potenziell
  iopAusmass: number; // 1 - 6
  iopUmfang: number; // 1 - 6
  iopWkt: number; // Wahrscheinlichkeit, 1 - 6, nur wenn IOPReal = 2 => also Thema potenziell bewertet
  iopBeschreibung: string; // Beschreibung was die positive Auswirkung ist
  iopBewertungGrund: string; // Begründung zur Bewertung
  iopBewertungWert: number; // Berechnet aus IOPAusmass, IOPUmfang und ggf. IOPWkt

  // Inside-Out Negativ (ION) Bewertung
  ionBewerten: boolean;
  ionReal: number; // 0 = nicht bewertet, 1 = tatsächlich, 2 = potenziell
  ionAusmass: number; // 1 - 6
  ionUmfang: number; // 1 - 6
  ionBehebbarkeit: number; // 1 - 6
  ionWkt: number; // Wahrscheinlichkeit, 1 - 6, nur wenn IONReal = 2 => also Thema potenziell bewertet
  ionBeschreibung: string; // Beschreibung was die negative Auswirkung ist
  ionBewertungGrund: string; // Begründung zur Bewertung
  ionBewertungWert: number; // Berechnet aus IONAusmass, IONUmfang, IONBehebbarkeit und ggf. IONWkt

  // Outside-In Chance (OIC) Bewertung
  oicBewerten: boolean;
  oicAuswirkung: number; // 1 - 6
  oicWkt: number; // Wahrscheinlichkeit, 1 - 6
  oicBeschreibung: string; // Beschreibung was die Chance ist
  oicBewertungGrund: string; // Begründung zur Bewertung
  oicBewertungWert: number; // Berechnet aus OICAuswirkung und OICWkt

  // Outside-In Risiko (OIR) Bewertung
  oirBewerten: boolean;
  oirAuswirkung: number; // 1 - 6
  oirWkt: number; // Wahrscheinlichkeit, 1 - 6
  oirBeschreibung: string; // Beschreibung was das Risiko ist
  oirBewertungGrund: string; // Begründung zur Bewertung
  oirBewertungWert: number; // Berechnet aus OIRAuswirkung und OIRWkt

  constructor(teinehmerguid: string, unternehmenguid: string, umfrageguid: string, longlistid: number) {
    this.id = 0;
    this.teilnehmerGuid = teinehmerguid;
    this.unternehmenGuid = unternehmenguid;
    this.umfrageGuid = umfrageguid;
    this.longlistId = longlistid;

    // Info
    this.insideOut = 0;
    this.outsideIn = 0;
    this.bothWays = 0;
    this.nr = 0;
    this.quelle = '';
    this.aspektDE = '';
    this.aspektEN = '';
    this.themaDE = '';
    this.themaEN = '';
    this.frageDE = '';
    this.frageEN = '';
    this.beschreibungDE = '';
    this.beschreibungEN = '';

    // Inside-Out Poistiv (IOP) Bewertung
    this.iopBewerten = false;
    this.iopReal = 0;
    this.iopAusmass = 0;
    this.iopUmfang = 0;
    this.iopWkt = 0;
    this.iopBeschreibung = '';
    this.iopBewertungGrund = '';
    this.iopBewertungWert = 0;

    // Inside-Out Negativ (ION) Bewertung
    this.ionBewerten = false;
    this.ionReal = 0;
    this.ionAusmass = 0;
    this.ionUmfang = 0;
    this.ionBehebbarkeit = 0;
    this.ionWkt = 0;
    this.ionBeschreibung = '';
    this.ionBewertungGrund = '';
    this.ionBewertungWert = 0;

    // Outside-In Chance (OIC) Bewertung
    this.oicBewerten = false;
    this.oicAuswirkung = 0;
    this.oicWkt = 0;
    this.oicBeschreibung = '';
    this.oicBewertungGrund = '';
    this.oicBewertungWert = 0;

    // Outside-In Risiko (OIR) Bewertung
    this.oirBewerten = false;
    this.oirAuswirkung = 0;
    this.oirWkt = 0;
    this.oirBeschreibung = '';
    this.oirBewertungGrund = '';
    this.oirBewertungWert = 0;
  }
}

export class GetUmfrageInfoRequest {
  unternehmenGuid: string;
  umfrageGuid: string;
  teilnehmerGuid: string;

  constructor(unternehmenGuid: string, umfrageGuid: string, teilnehmerGuid: string) {
    this.unternehmenGuid = unternehmenGuid;
    this.umfrageGuid = umfrageGuid;
    this.teilnehmerGuid = teilnehmerGuid;
  }
}

export interface UmfrageInfo {
  unternehmen: string;
  ansprechpartner: string;
  umfrage: string;
  teilnehmer: string;
}
